import { InjectionToken } from "@angular/core";
import { ShoppingCartRepository } from "../contracts/shopping-cart.repository";

export const SHOPPING_CART_REPOSITORY_TOKEN =
  new InjectionToken<ShoppingCartRepository>("SHOPPING_CART_REPOSITORY_TOKEN");
